import { useState } from "react";
import { AppShell } from "../app/AppShell";
import { useMe } from "../app/AuthGate";
import { AccountInfo, PasswordCard, TokenWhereCard } from "../components/Auth";
import { PageHead } from "../components/Page";
import { TotpAccountCard } from "../components/Totp";
import "../components/Auth.css";
import { authApi, authErrText } from "../lib/auth";
import { tx } from "../i18n";

/* ══ 내 계정 · 보안(#/account) — 공통 ③(Figma 92-2) ══
   내비 링크를 늘리지 않고 계정 메뉴에서만 연다. hub 로 들어온 세션에는 2단계 카드를 안 그린다 —
   그 사람의 2단계는 hub 가 묻는다(auth.md §7). */
export function AccountPage() {
  const auth = useMe();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function change(current: string, next: string) {
    setBusy(true);
    setError(null);
    setDone(false);
    try {
      await authApi.changePassword({ current, next });
      setDone(true);
    } catch (e) {
      setError(authErrText(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <AppShell route="/account">
      <PageHead
        title={tx("account.title")}
        lead={tx("account.lead")}
      />
      {auth ? (
        <div className="acctgrid">
          <AccountInfo me={auth.me} />
          <PasswordCard hasPassword={auth.me.hasPassword} busy={busy} error={error} done={done} onSubmit={change} />
          {auth.me.hasPassword && auth.me.via !== "sso" ? (
            <TotpAccountCard
              enabled={auth.me.totpEnabled}
              required={auth.me.totpRequired}
              fns={{
                onSetup: authApi.totpSetup,
                onConfirm: async (code) => {
                  await authApi.totpConfirm(code);
                },
                onDisable: async (pw) => {
                  await authApi.totpDisable(pw);
                },
                onEnrolled: auth.refreshMe,
                onDisabled: auth.refreshMe,
              }}
            />
          ) : null}
          <TokenWhereCard isAdmin={auth.me.role === "admin"} />
        </div>
      ) : null}
    </AppShell>
  );
}
